export const getFullname = ({ firstName, lastName }) => {
  return `${firstName ? firstName : ""} ${lastName ? lastName : ""}`.trim();
};
